export const LOCALE_FLAG: Record<string, string> = {
    en_GB: `🇬🇧`,
    es_ES: `🇪🇸`,
    fr_FR: `🇫🇷`
}